import React, { useState, useContext } from "react";
import { Button, DialogActions, TextField as MuiTextField, Grid, makeStyles, FormControl } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { userServices } from "../services";
import { AuthContext } from "../context";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, ModalBase } from "./";

export default function EditLaboratory(props) {
	const { specialtiesList, data } = props;

	const classes = useStyles();
	const { register, handleSubmit, errors } = useForm({
		shouldUnregister: false,
	});
	const { authState } = useContext(AuthContext);
	const [laboratory] = useState(data);
	const [specialties, setSpecialties] = useState(laboratory.specialties || []);


	const editLaboratory = async (dataToInsert) => {
		const user = {
			username: dataToInsert.username,
			email: dataToInsert.email,
			laboratory: {
				name: dataToInsert.name,
				specialties,
			},
		};
		const { status, response } = await userServices.updateUser({ _id: laboratory.user._id, token: authState.token, user });
		switch (status) {
			case 200:
				props.close();
				props.reload();
				props.toast("Laboratorio actualizado con exito", true);
				break;
			case 400:
				props.toast(response.error.message, true);
				break;
			default:
				break;
		}
	};

	return (
		<ModalBase open={props.open} close={props.close} title="Editar laboratorio">
			<form className={classes.form} onSubmit={handleSubmit(editLaboratory)}>
				<Grid container spacing={2}>
					{laboratory.user && (
						<Grid item xs={12} sm={12}>
							<TextField
								variant="outlined"
								fullWidth
								id="name"
								label="Nombre"
								placeholder="Nombre *"
								name="name"
								autoComplete="name"
								defaultValue={laboratory.name}
								size="small"
								inputRef={register({
									required: "Nombre requerido",
								})}
								InputLabelProps={{
									shrink: true,
								}}
								error={errors.name ? true : false}
								helperText={errors.name ? errors.name.message : ""}
							/>
						</Grid>
					)}
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="username"
							label="Usuario"
							name="username"
							placeholder="Usuario *"
							autoComplete="username"
							defaultValue={laboratory.user ? laboratory.user.username : laboratory.username}
							size="small"
							inputRef={register({
								required: "Usuario requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.username ? true : false}
							helperText={errors.username ? errors.username.message : ""}
						/>
					</Grid>

					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="email"
							label="Correo electrónico"
							name="email"
							size="small"
							placeholder="Email *"
							autoComplete="email"
							defaultValue={laboratory.user ? laboratory.user.email : laboratory.email}
							inputRef={register({
								required: "Correo requerido",
								pattern: {
									value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
									message: "Formato de correo inválido",
								},
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.email ? true : false}
							helperText={errors.email ? errors.email.message : ""}
						/>
					</Grid>
					{laboratory.user && (
						<Grid item lg={12} xs={12} sm={12}>
							<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
								<Autocomplete
									multiple
									id="especialidades"
									options={specialtiesList}
									getOptionLabel={(option) => option.name}
									filterSelectedOptions
									variant="outlined"
									label="Especialidades"
									value={specialties}
									onChange={(event, newValue) => {
										setSpecialties(newValue);
									}}
									renderInput={(params) => (
										<MuiTextField
											{...params}
											id="especialidades"
											name="especialidades"
											variant="outlined"
											label="especialidades"
											placeholder="especialidades"
										/>
									)}
								/>
							</FormControl>
						</Grid>
					)}
					{/*                         <Grid item xs={12} sm={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="password"
                                label="Contrasena"
                                name="password"
                                type="password"
                                autoComplete="password"
                                size="small"
                                inputRef={register({
                                    required: "Contrasena requerida"
                                })}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                error={errors.password ? true : false}
                                helperText={errors.password ? errors.password.message : ""}
                            />
                        </Grid> */}
				</Grid>
				<DialogActions>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="secondary"
						className={classes.submit}
						style={{ textTransform: "capitalize", borderRadius: "20px" }}
					>
						Guardar
					</Button>
				</DialogActions>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(2),
		top: theme.spacing(2),
		color: "#FFF",
		backgroundColor: theme.palette.secondary.main,
		height: 30,
		width: 30,
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	dialogTitle: {
		textAlign: "left",
		color: theme.palette.primary.main,
		"& h2": {
			fontWeight: "bold",
		},
	},
	formControl: {
		width: "100%",
		minWidth: 120,
		"& div": {
			borderRadius: 25,
		},
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
}));
